import { set } from "@vueuse/core";
import { type Ref, ref, toValue, watch } from "vue";
import type { Config } from "../domain/config.type.js";
import { type DateOption, generateDates } from "../utils/generators.js";

export function useDates(config: Ref<Config>) {
	const dates: Ref<DateOption[]> = ref(generateDates(toValue(config)));

	watch(config, (_config) => {
		set(dates, generateDates(_config));
	});

	return { dates };
}
